module.exports = __webpack_public_path__ + "static/section_notice_2-f134aef91e6c2a6a449695f4505a27c6.png";